import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FileRestService} from '@core/modules/rest/file/file-rest.service';
import {Store} from '@ngrx/store';
import {AppState} from '@core/reducers';
import {FileModel} from '@core/modules/rest/file/file.model';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ListPopupComponent} from '@shared/dialogs/list-popup/list-popup.component';
import {UntilDestroy} from '@ngneat/until-destroy';
import {NotificationService} from '@shared/components/notification/service/notification.service';
import {TranslateService} from '@ngx-translate/core';

@UntilDestroy()
@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {

    @ViewChild('uploadFile', {static: false}) uploadFile: ElementRef;
    @Input() uploadFinished = true;
    @Output() emitUploadedImage = new EventEmitter<FileModel>();
    @Output() deleteEvent = new EventEmitter<any>();
    @Output() emitNumberOfFilesToUpload = new EventEmitter<number>();

    files: File[] = [];

    constructor(private store: Store<AppState>, private fileRestService: FileRestService,
                private dialog: MatDialog, private notificationService: NotificationService,
                private translate: TranslateService) {
    }

    onChooseFiles(event): void {
        this.files = event.target.files;
        if (this.files.length > 0) {
            this.openFilesListPopup();
        }
    }

    uploadFiles(): void {
        this.emitNumberOfFilesToUpload.emit(this.files.length);
        Array.from(this.files).forEach(file => {
            this.fileRestService.upload(file).subscribe(response => {
                if (response.supportedMediaType) {
                    this.emitUploadedImage.emit(response.fileInfo);
                } else {
                    this.uploadFinished = true;
                    this.notificationService.warn(this.translate.instant('GENERAL.UNSUPPORTED_MEDIA_TYPE'));
                }
            });
        });
    }

    openFilesListPopup(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.panelClass = 'abstract-dialog-container';

        dialogConfig.data = {
            files: this.files
        };
        const dialogRef = this.dialog.open(ListPopupComponent, dialogConfig);
        const uploadFiles = dialogRef.componentInstance.uploadEvent.subscribe(data => {
            this.files = data;
            if (data !== undefined) {
                this.uploadFiles();
            }
        });
        dialogRef.afterClosed().subscribe(() => {
            if (this.uploadFile) {
                this.uploadFile.nativeElement.value = '';
                uploadFiles.unsubscribe();
            }
        });
    }
}
